// extracted by mini-css-extract-plugin
module.exports = {"tags":"product-detail-tags_tags__5iyQc","tag":"product-detail-tags_tag__vtIox"};